import { t } from "i18next";
import { Card, Typography } from "@material-tailwind/react";
import { GenericListLayout } from "../../../components/generic-list-view/GenericListLayout";
import { getFleetNumber, getHourMeter } from "../../../services/machine/machine";

/**
* InformationsTab: display machine informations
* @param data - machine data
*/
const InformationsTab = ({ data }: { data: EasyTech.Machine }) => {
  
  const content = (
    <Card className="information-content mt-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <div className="field">
            <label>{t("machine:form:fields:brand:label")}</label>
            <Typography>{data.brand?.label || "-"}</Typography>
          </div>

          <div className="field">
            <label>{t("machine:form:fields:serialNumber:label")}</label>
            <Typography>{data.serialNumber || "-"}</Typography>
          </div>

          <div className="field">
            <label>{t("machine:form:fields:releaseYear:label")}</label>
            <Typography>{data.releaseYear || "-"}</Typography>
          </div>

          <div className="field">
            <label>{t("machine:form:fields:fleetNumber:label")}</label>
            <Typography>{getFleetNumber(data) || "-"}</Typography>
          </div>
        </div>

        <div>
          <div className="field">
            <label>{t("machine:form:fields:type:label")}</label>
            <Typography>{data.type?.label || "-"}</Typography>
          </div>

          <div className="field">
            <label>{t("machine:form:fields:model:label")}</label>
            <Typography>{data.model || "-"}</Typography>
          </div>

          <div className="field">
            <label>{t("machine:form:fields:hourMeter:label")}</label>
            <Typography>{getHourMeter(data) || "-"}</Typography>
          </div>
        </div>
      </div>

      <div className="field mt-6">
        <label>{t("machine:form:fields:notes:label")}</label>
        <Typography className="whitespace-pre-wrap">{data.notes || "-"}</Typography>
      </div>
    </Card>
  );

  return (
    <GenericListLayout
      entityName={t("common:general")}
      isLoading={false}
      content={content}
      showBreadcrumb={false}
    />
  );
};

export default InformationsTab; 